<template>
    <div class="animated fadeIn">
        <div v-if="loading" class="loader-wrapper">
            <atom-spinner
                :animation-duration="1000"
                :size="60"
                color="#ff1d5e"
            />
        </div>
        <div>
            <b-row class="mt-1 dashboard-header">
                <b-col cols="12" md="9">
                    <p class="dash-text">Dashboard</p>
                </b-col>
                <b-col cols="12" md="3" class="py-0 dashboard-drop">
                    <eb-select
                        v-if="$userRole !== 'Admin'"
                        ref="dateRef1"
                        class="dashboard-select"
                        id="tenantAnalyticReport"
                        type="text"
                        label="text"
                        v-model="selectedDate1"
                        :selected="selectedDate1.text"
                        :options="dayRadioOption"
                        @input="changeDate1"
                    ></eb-select>
                    <c-date
                        ref="compRefs1"
                        modalRef="modalRef1"
                        modalId="dateModal1"
                        @customDateRange="findDateResult1"
                    ></c-date>
                </b-col>
            </b-row>
        </div>
        <b-card class="mt-2">
            <b-row v-if="$userRole == 'Admin'">
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Tenants"
                        :value="adminDashboard.tenantCount"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Markets"
                        :value="adminDashboard.totalMarkets"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Users"
                        :value="adminDashboard.totalUsers"
                        bottomColor="#ff3a3a"
                    >
                    </dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Attributes"
                        :value="adminDashboard.totalAttributes"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Total Roles"
                        :value="adminDashboard.totalRoles"
                        bottomColor="#ffaf37"
                    >
                    </dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Total Permissions"
                        :value="adminDashboard.totalPermissions"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Total Features"
                        :value="adminDashboard.totalFeatures"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Total Subscriptions"
                        :value="adminDashboard.totalSubscriptions"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Total Business Plan"
                        :value="adminDashboard.totalBusinessPlans"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
            </b-row>
            <b-row v-if="$userRole == 'Tenant'">
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Partners"
                        :value="dashboard.partnerCount"
                        routePath="/partner"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Customers"
                        :value="dashboard.totalCustomers"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Orders"
                        routePath="/manage-order"
                        :value="dashboard.totalOrders"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Items"
                        :value="dashboard.totalItems"
                        bottomColor="#4caf50"
                    >
                    </dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Order Amount"
                        routePath="/manage-order"
                        :value="dashboard.totalAmount"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        routePath="/setup/service-request"
                        labelText="No Of SR / Ticket 1 Month"
                        :value="dashboard.totalService"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <!-- TENANT -->
            </b-row>
            <b-row
                v-if="this.$currentUserData.category == 'SELLER'"
                class="dashboard-summary-row"
            >
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Orders"
                        routePath="/manage-order"
                        :value="dashboard.totalOrders"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Order Completed"
                        routePath="/manage-order"
                        :value="dashboard.totalOrderCompleted"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Cancelled Order"
                        routePath="/manage-order"
                        :value="dashboard.totalCancelledOrders"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Returned Order"
                        routePath="/manage-order"
                        :value="dashboard.totalReturnedOrders"
                        bottomColor="#4caf50"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Total Items"
                        routePath="/item"
                        :value="dashboard.totalItems"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Item Sold Out"
                        :value="dashboard.totalItemSoldOut"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Total Low Stock Items"
                        :value="dashboard.totalItemLowStock"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Predicted Stock-Out
                            Next 7 Days"
                        :value="dashboard.predictedStock"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Risk Stock Items"
                        :value="dashboard.riskStock"
                        bottomColor="#ff3a3a"
                    >
                    </dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        labelText="Pending Approval"
                        :value="dashboard.totalPendingApproval"
                        bottomColor="#42b039"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        routePath="/item"
                        labelText="Online Items"
                        :value="dashboard.totalOnlineItems"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        routePath="/item"
                        labelText="Offline Items"
                        :value="dashboard.totalOfflineItems"
                        bottomColor="var(--secondary)"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3" class="mt-2">
                    <dashboardInfoCard
                        routePath="/manage-order"
                        labelText="Live Orders"
                        :value="dashboard.totalLiveOrders"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <!-- SELLER -->
            </b-row>
            <b-row
                v-if="
                    this.$currentUserData.category == 'DISTRIBUTOR' ||
                    this.$currentUserData.category == 'DEALER'
                "
            >
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="New/Total Partners"
                        :value="`${distributor.newPartner}/${distributor.totalPartner}`"
                        routePath="/partner"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="New/Total Items"
                        :value="`${distributor.newItems}/${distributor.totalItems}`"
                        bottomColor="#4c4be8"
                    >
                    </dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Order Count"
                        routePath="/manage-order"
                        :value="distributor.orderCount"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Order Amount"
                        routePath="/manage-order"
                        :value="`रु ${distributor.orderAmount}`"
                        bottomColor="#4caf50"
                    ></dashboardInfoCard>
                </b-col>
            </b-row>
            <b-row
                class="md-mt-3"
                v-if="
                    $currentUserData.category === 'DISTRIBUTOR' ||
                    $currentUserData.category === 'DEALER'
                "
            >
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Total Agent"
                        routePath="/user"
                        :value="distributor.totalAgent"
                        bottomColor="#ffaf37"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Failed Payment"
                        routePath="/payment-history"
                        :value="distributor.totalFailedPayment"
                        bottomColor="#4c4be8"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="Active Seller"
                        routePath="/partner"
                        :value="distributor.totalActiveSeller"
                        bottomColor="#ff3a3a"
                    ></dashboardInfoCard>
                </b-col>
                <b-col sm="6" lg="3">
                    <dashboardInfoCard
                        labelText="New seller"
                        :value="distributor.totalNewSeller"
                        bottomColor="#4caf50"
                    >
                    </dashboardInfoCard>
                </b-col>
            </b-row>
        </b-card>
        <div v-if="$currentUserData.category == 'SELLER'">
            <!-- <b-card>
                <b-table :items="products" :fields="fields" responsive hover>
                    <template #cell(images.icon)="data">
                        <div class="d-flex align-items-center">
                            <div>
                                <img
                                    :src="data.item.images.icon"
                                    alt="Product Image"
                                    class="img-fluid product-img"
                                />
                            </div>
                        </div>
                    </template>
                    <template #cell(itemName)="data">
                        <div class="d-flex align-items-center">
                            <div>
                                <div class="font-weight-bold">
                                    {{ data.item.itemName || "NA" }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template #cell(stockCount)="data">
                        <span class="font-weight-bold">{{
                            data.item.stockCount || "N/A"
                        }}</span>
                    </template>
                    <template #cell(requiredNext7Days)="data">
                        <span class="text-danger font-weight-bold">{{
                            data.item.requiredNext7Days || "N/A"
                        }}</span>
                    </template>
                </b-table>
            </b-card> -->
        </div>
        <b-row
            class="mt-0"
            v-if="
                $userRole == 'Admin' ||
                this.$currentUserData.category == 'SELLER' ||
                $userRole == 'Tenant'
            "
        >
            <b-col cols="12" lg="7" class="pb-0 mb-3 mb-lg-0">
                <b-row>
                    <b-col v-if="$userRole == 'Admin'" cols="12">
                        <p class="py-1 dash-text">Order Chart</p>
                    </b-col>

                    <b-col v-if="$userRole !== 'Admin'" cols="12" md="8">
                        <p class="py-1 tenant-dash-text">Order Chart</p>
                    </b-col>
                    <b-col
                        v-if="$userRole !== 'Admin'"
                        cols="12"
                        md="4"
                        class="py-0 dashboard-drop"
                    >
                        <eb-select
                            ref="dateRef2"
                            class="dashboard-select w-100"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedDate2"
                            :selected="selectedDate2.text"
                            @input="changeDate2"
                            :options="dayRadioOption"
                        ></eb-select>
                    </b-col>

                    <b-col cols="12" sm="6" md="4" class="mb-2 mb-md-0"
                        ><eb-select
                            v-if="$userRole == 'Admin'"
                            class="dashboard-select"
                            id="text"
                            type="text"
                            label="text"
                            placeholder="Select Status"
                            :options="statusOptions"
                            v-model="selectedStatusOptions"
                            :selected="selectedStatusOptions"
                            @input="changeStatus"
                        >
                        </eb-select
                    ></b-col>
                    <b-col cols="12" sm="6" md="4" class="mb-2 mb-md-0">
                        <eb-select
                            class="dashboard-select"
                            label="text"
                            v-model="selectedTenant"
                            v-if="$userRole == 'Admin'"
                            :selected="selectedTenant.text"
                            @input="changeTenant"
                            :options="tenantList"
                            placeholder="Select a tenant"
                        ></eb-select>
                    </b-col>
                    <b-col cols="12" sm="12" md="4">
                        <eb-select
                            ref="dateRef2"
                            v-if="$userRole == 'Admin'"
                            class="dashboard-select"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedDate2"
                            :selected="selectedDate2.text"
                            @input="changeDate2"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs2"
                            modalRef="modalRef2"
                            modalId="dateModal2"
                            @customDateRange="findDateResult2"
                        ></c-date>
                    </b-col>
                </b-row>
                <b-card class="chartSec">
                    <div v-if="hasChartData">
                        <BarChart
                            v-if="!isLoading"
                            :chart-data="barChartData"
                            :chart-options="barChartOptions"
                        />
                    </div>
                    <div v-else class="noDataAvai">
                        <h4 class="text-center mb-0">No Data Available</h4>
                    </div>
                </b-card>
            </b-col>
            <b-col cols="12" lg="5" class="pb-0">
                <b-row>
                    <b-col v-if="$userRole == 'Admin'" cols="12">
                        <p class="py-1 dash-text">Top Revenue Market</p>
                    </b-col>
                    <b-col v-if="$userRole !== 'Admin'" cols="12" md="7">
                        <p class="py-1 tenant-dash-text">Top Revenue Market</p>
                    </b-col>
                    <b-col
                        v-if="$userRole !== 'Admin'"
                        cols="12"
                        md="5"
                        class="py-0 dashboard-drop"
                    >
                        <eb-select
                            ref="dateRef3"
                            class="dashboard-select w-100"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedDate3"
                            :selected="selectedDate3.text"
                            @input="changeDate3"
                            :options="dayRadioOption"
                        ></eb-select>
                    </b-col>
                    <b-col cols="12" sm="6" md="6" class="mb-2 mb-md-0">
                        <eb-select
                            class="dashboard-select"
                            v-if="$userRole == 'Admin'"
                            id="tenantAnalyticReport"
                            type="text"
                            label="text"
                            v-model="selectedTenant2"
                            :selected="selectedTenant2.text"
                            @input="changeTenant"
                            :options="tenantList"
                            placeholder="Select a tenant"
                        ></eb-select>
                    </b-col>
                    <b-col cols="12" sm="6" md="6">
                        <eb-select
                            ref="dateRef3"
                            class="dashboard-select"
                            id="tenantAnalyticReport"
                            v-if="$userRole == 'Admin'"
                            type="text"
                            label="text"
                            v-model="selectedDate3"
                            :selected="selectedDate3.text"
                            @input="changeDate3"
                            :options="dayRadioOption"
                        ></eb-select>
                        <c-date
                            ref="compRefs3"
                            modalRef="modalRef3"
                            modalId="dateModal3"
                            @customDateRange="findDateResult3"
                        ></c-date>
                    </b-col>
                </b-row>
                <b-card class="chartSec">
                    <div
                        v-if="
                            getDoughChartData &&
                            getDoughChartData.labels &&
                            getDoughChartData.labels.length
                        "
                    >
                        <Doughnut
                            v-if="!isTopMarketLoading"
                            class="doughnut chart-doughnut"
                            :chart-data="getDoughChartData"
                            :chart-options="chartOptions"
                        >
                        </Doughnut>
                    </div>
                    <div v-else class="noDataAvai">
                        <h4 class="text-center">No Data Available</h4>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Doughnut from "@/components/chart/Doughnut.js";
import tenantDoughnutChart from "@/utils/tenantDoughnutChart";
import BarChart from "@/components/chart/BarChart.vue";
import orderDataBarChart from "@/utils/orderDataBarChart";
import ebSelect from "@/components/FormElements/Select.vue";
import cDate from "@/components/FormElements/CustomDate.vue";
import dashboardInfoCard from "@/components/Generics/dashboardInfoCard.vue";
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";
export default {
    name: "dashboard",
    components: {
        AtomSpinner,
        dashboardInfoCard,
        Doughnut,
        BarChart,
        ebSelect,
        cDate,
    },
    data: function () {
        return {
            prevSelectedDate1: null,
            prevSelectedDate2: null,
            prevSelectedDate3: null,
            // category: { id: "all", text: "All Categories" },
            // risk: { id: "high_to_low", text: "High to Low" },
            // categories: [
            //     { id: "all", text: "All Categories" },
            //     { id: "electronics", text: "Electronics" },
            //     { id: "wearables", text: "Wearables" },
            //     { id: "home_appliances", text: "Home Appliances" },
            // ],
            // riskLevels: [
            //     { id: "high_to_low", text: "High to Low" },
            //     { id: "low_to_high", text: "Low to High" },
            // ],
            // fields: [
            //     { key: "images.icon", label: "Product Image" },
            //     { key: "itemName", label: "Product" },
            //     { key: "stockCount", label: "Current Stock" },
            //     { key: "requiredNext7Days", label: "Stock-Out In" },
            // ],
            // products: [],
            selectedStatusOptions: [],
            statusOptions: [
                "All Status",
                "Delivered",
                "Created",
                "Out For Delivery",
                "Payment Failed",
                "Cancelled",
                "Rejected",
                "Returned",
                "Dispatched",
                "Refund",
                "Delivery Attached",
                "Confirmed",
            ],
            selectedTenant: {
                text: "All Tenants",
                value: 123,
            },
            selectedTenant2: {
                text: "All Tenants",
                value: 123,
            },
            adminDashboard: {
                tenantCount: 0,
                totalMarkets: 0,
                totalUsers: 0,
                totalAttributes: 0,
                totalRoles: 0,
                totalPermissions: 0,
                totalFeatures: 0,
                totalSubscriptions: 0,
                totalBusinessPlans: 0,
            },
            dashboard: {
                partnerCount: 0,
                totalItems: 0,
                totalCustomers: 0,
                totalOrders: 0,
                totalAmount: 0,
                totalService: 0,
                totalAgent: 0,
                totalActiveSeller: 0,
                totalNewSeller: 0,
                totalUpcomingRenewal: 0,
                totalSellerRenewalDue: 0,
                totalFailedPayment: 0,
                totalOrderCompleted: 0,
                totalLiveOrders: 0,
                totalCancelledOrders: 0,
                totalReturnedOrders: 0,
                totalItemSoldOut: 0,
                totalPendingApproval: 0,
                totalOfflineItems: 0,
                totalOnlineItems: 0,
                totalItemLowStock: 0,
                predictedStock: 0,
                riskStock: 0,
            },
            distributor: {
                newPartner: 0,
                totalPartner: 0,
                newItems: 0,
                totalItems: 0,
                orderCount: 0,
                orderAmount: 0,
                totalAgent: 0,
                totalFailedPayment: 0,
                totalActiveSeller: 0,
                totalNewSeller: 0,
            },
            loading: false,
            selectedDate1: {
                text: "Today",
                value: 0,
            },
            selectedDate2: {
                text: "Today",
                value: 0,
            },
            selectedDate3: {
                text: "Today",
                value: 0,
            },
            startDate: "",
            endDate: "",
            isTopMarketLoading: false,
            dayRadioOption: [
                {
                    text: "Today",
                    value: 0,
                },
                {
                    text: "7 days",
                    value: 6,
                },
                {
                    text: "30 days",
                    value: 29,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            isLoading: false,
        };
    },
    computed: {
        ...mapState({
            allTenantList: (state) => state.tenant.tenantsList,
        }),
        hasChartData() {
            return this.barChartData?.datasets?.some((ds) =>
                ds.data.some((value) => value > 0),
            );
        },
        tenantList() {
            let tenantData = [
                {
                    text: "All Tenants",
                    value: 123,
                },
            ];
            this.allTenantList.forEach((el) => {
                if (el.status == "Active") {
                    let obj = {
                        text: el.authentication.userName,
                        value: el._id,
                    };
                    tenantData.push(obj);
                }
            });
            return tenantData;
        },
        tenantId() {
            let id = "";
            if (
                ["SELLER", "DISTRIBUTOR", "DEALER"].includes(
                    this.$currentUserData.category,
                )
            ) {
                id = this.$store.getters["auth/getTenant"];
            }
            return id;
        },
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        barChartData() {
            let data = this.$store.getters["partner/getBulkAnalyticsReport"];
            let orderkey = "";
            let orderAmount = "";
            let orderCount = "";
            if (this.$userRole == "Tenant") {
                orderkey = "total-order-report-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            if (this.$userRole == "Admin") {
                orderkey = "orderbyvalue-graph";
                if (this.selectedTenant.text === "All Tenants") {
                    orderkey = "all-tenants-orderbyvalue-graph";
                }
                if (this.selectedTenant2.text === "All Tenants") {
                    orderkey = "all-tenants-orderbyvalue-graph";
                }
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            if (this.$currentUserData.category === "SELLER") {
                orderkey = "seller-total-order-report-graph";
                orderAmount = "orderamount";
                orderCount = "ordercount";
            }
            const orderList = data[orderkey];
            return orderDataBarChart(orderList, orderAmount, orderCount);
        },
        barChartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                    },
                    y: {
                        stacked: false,
                        grid: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            callback: function (value) {
                                const valueLegend =
                                    this.getLabelForValue(value);
                                const valueLegendRep = valueLegend.replaceAll(
                                    ",",
                                    "",
                                );
                                if (Number(valueLegendRep) < 2) {
                                    return valueLegendRep * 10;
                                } else {
                                    const valueShort =
                                        Number(valueLegendRep) / 1000;
                                    return valueShort + " " + "k";
                                }
                            },
                        },
                    },
                },
                plugins: {
                    tooltip: {
                        callbacks: {
                            label: (tooltipItem) => {
                                let data =
                                    this.$store.getters[
                                        "partner/getBulkAnalyticsReport"
                                    ];

                                let orderReportData = [];
                                if (this.$userRole == "Tenant") {
                                    orderReportData =
                                        data["total-order-report-graph"];
                                }
                                if (
                                    this.$currentUserData.category === "SELLER"
                                ) {
                                    orderReportData =
                                        data["seller-total-order-report-graph"];
                                }
                                if (this.$userRole == "Admin") {
                                    orderReportData =
                                        data["orderbyvalue-graph"];
                                    if (
                                        this.selectedTenant.text ===
                                        "All Tenants"
                                    ) {
                                        orderReportData =
                                            data[
                                                "all-tenants-orderbyvalue-graph"
                                            ];
                                    }
                                }
                                let selctedData = orderReportData.find(
                                    (e) => e.orderamount == tooltipItem.raw,
                                );
                                let showTooltip1 = [];
                                showTooltip1.push(
                                    `${selctedData.orderamount}: Order Amount`,
                                );
                                showTooltip1.push(
                                    `${selctedData.ordercount}: Order Count`,
                                );
                                return showTooltip1;
                            },
                        },
                    },
                },
            };
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        position: "bottom",
                    },
                },
            };
            // hoverBorderWidth: 10,
        },
        getDoughChartData() {
            let dataList = this.$store.getters["partner/getTopMarketChartData"];
            let dataKey = undefined;
            if (this.$userRole == "Tenant") {
                dataKey = "top-revenue-market-report";
            }
            if (this.$currentUserData.category === "SELLER") {
                dataKey = "seller-top-revenue-market-report";
            }
            if (this.$userRole === "Admin") {
                dataKey = "admin-top-revenue-market-report";
            }
            return tenantDoughnutChart(dataList, dataKey);
        },
    },
    methods: {
        async sellerStockPrediction() {
            const data = await this.$store.dispatch("tenant/stockPrediction");
            this.products = data?.data?.response[0]?.items || [];
            this.dashboard.predictedStock =
                data?.data?.response[0]?.totalRequiredNext7Days[0].totalRequired;
        },
        async sellerDashboardData() {
            const payload = {
                lowStock: 10,
                inventoryType: "2",
            };
            const data = await this.$store.dispatch(
                "tenant/lowStockPrediction",
                payload,
            );
            this.dashboard.totalItemLowStock =
                data?.data?.response[0]?.totalItems || "0";
            const payload1 = {
                lowStock: 5,
                inventoryType: "2",
            };
            const data1 = await this.$store.dispatch(
                "tenant/lowStockPrediction",
                payload1,
            );
            this.dashboard.riskStock =
                data1?.data?.response[0]?.totalItems || "0";
        },
        changeDate1(e) {
            if (e.value === "custom") {
                this.prevSelectedDate1 = { ...this.selectedDate1 };
                this.selectedDate1 = this.prevSelectedDate1;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].close
                    ) {
                        this.$refs["dateRef1"].close();
                    } else if (
                        this.$refs["dateRef1"] &&
                        this.$refs["dateRef1"].$el
                    ) {
                        const el =
                            this.$refs["dateRef1"].$el.querySelector("input") ||
                            this.$refs["dateRef1"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs1"].openModal();
                });
                return;
            }
            if (this.$userRole == "Tenant") {
                this.getTenantAnalyticsData();
                return;
            }
            if (
                ["DISTRIBUTOR", "DEALER", "SUB_DEALER"].includes(
                    this.$currentUserData.category,
                )
            ) {
                this.getDealerDistributorInfo();
            }
            if (this.$currentUserData.category === "SELLER") {
                this.getSellerDashboardInfo();
                return;
            }
        },
        changeTenant(e) {
            this.fetchAdminOrderChart();
        },
        changeStatus(e) {
            const value = Array.isArray(e) ? e : e != null ? [e] : [];
            if (value.some((el) => el === "All Status")) {
                if (value.indexOf("All Status") === 0 && value.length > 1) {
                    const next = [...value];
                    next.splice(next.indexOf("All Status"), 1);
                    this.selectedStatusOptions = next;
                } else {
                    this.selectedStatusOptions = ["All Status"];
                }
            } else {
                this.selectedStatusOptions = value;
            }
            this.fetchAdminOrderChart();
        },
        changeDate2(e) {
            if (e.value === "custom") {
                this.prevSelectedDate2 = { ...this.selectedDate2 };
                this.selectedDate2 = this.prevSelectedDate2;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef2"] &&
                        this.$refs["dateRef2"].close
                    ) {
                        this.$refs["dateRef2"].close();
                    } else if (
                        this.$refs["dateRef2"] &&
                        this.$refs["dateRef2"].$el
                    ) {
                        const el =
                            this.$refs["dateRef2"].$el.querySelector("input") ||
                            this.$refs["dateRef2"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs2"].openModal();
                });
                return;
            }
            if (this.$userRole == "Tenant") {
                this.fetchTenantOrderChart();
            } else if (this.$userRole == "Admin") {
                this.fetchAdminOrderChart();
            } else {
                this.fetchSellerOrderChart();
            }
        },
        changeDate3(e) {
            if (e.value === "custom") {
                this.prevSelectedDate3 = { ...this.selectedDate3 };
                this.selectedDate3 = this.prevSelectedDate3;
                this.$nextTick(() => {
                    if (
                        this.$refs["dateRef3"] &&
                        this.$refs["dateRef3"].close
                    ) {
                        this.$refs["dateRef3"].close();
                    } else if (
                        this.$refs["dateRef3"] &&
                        this.$refs["dateRef3"].$el
                    ) {
                        const el =
                            this.$refs["dateRef3"].$el.querySelector("input") ||
                            this.$refs["dateRef3"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs3"].openModal();
                });
                return;
            }
            if (this.$userRole == "Admin") {
                this.fetchAdminTopMarketRevenue();
            } else if (this.$userRole == "Tenant") {
                this.fetchTopMarketRevenueData();
            } else {
                this.fetchSellerTopMarketRevenue();
            }
        },
        findDateResult1(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.selectedDate1 = {
                text: `${moment(e.fromDate).format("DD-MM-YYYY")} - ${moment(
                    e.toDate,
                ).format("DD-MM-YYYY")}`,
                value: "custom",
            };
            if (this.$userRole == "Tenant") {
                this.getTenantAnalyticsData();
            } else {
                this.getDealerDistributorInfo();
            }
        },
        findDateResult2(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.selectedDate2 = {
                text: `${moment(e.fromDate).format("DD-MM-YYYY")} - ${moment(
                    e.toDate,
                ).format("DD-MM-YYYY")}`,
                value: "custom",
            };
            if (this.$userRole == "Tenant") {
                this.fetchTenantOrderChart();
            }
            if (this.$userRole == "Admin") {
                this.fetchAdminOrderChart();
            } else {
                this.fetchSellerOrderChart();
            }
        },
        findDateResult3(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.selectedDate3 = {
                text: `${moment(e.fromDate).format("DD-MM-YYYY")} - ${moment(
                    e.toDate,
                ).format("DD-MM-YYYY")}`,
                value: "custom",
            };
            if (this.$userRole == "Admin") {
                this.fetchAdminTopMarketRevenue();
            }
            if (this.$userRole == "Tenant") {
                this.fetchTopMarketRevenueData();
            } else {
                this.fetchSellerTopMarketRevenue();
            }
        },
        getDateInfo(dateData) {
            if (dateData == "custom") {
                const data = {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
                return data;
            }
            if (typeof dateData === "number") {
                const data = {
                    fromDate: moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            }
        },
        async getDealerDistributorInfo() {
            let user = this.$currentUserData.category
                .toLowerCase()
                .replace("_", "");
            const itemList = [
                `${user}-total-new-merchant`,
                `${user}-total-orders`,
                `${user}-total-failed-payment`,
                `${user}-total-agents`,
                `${user}-total-new-items`,
                `${user}-total-active-seller`,
                `${user}-total-active-seller`,
            ];
            let items = [];
            let variablesObj = {
                tenant: this.tenantId,
                ...this.getDateInfo(this.selectedDate1.value),
                userId: this.userId,
            };
            itemList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {
                        ...variablesObj,
                    },
                });
            });
            try {
                const data = await this.$store.dispatch(
                    "partner/fetchBulkAnalyticReport",
                    {
                        items: items,
                    },
                );
                this.distributor.newPartner =
                    data[`${user}-total-new-merchant`]?.count || 0;
                this.distributor.newItems =
                    data[`${user}-total-new-items`]?.items || 0;
                this.distributor.orderCount =
                    data[`${user}-total-orders`]?.total_order || 0;
                this.distributor.orderAmount =
                    data[`${user}-total-orders`]?.total_order_amount || 0;
                this.distributor.totalAgent =
                    data[`${user}-total-agents`]?.count || 0;
                this.distributor.totalFailedPayment =
                    data[`${user}-total-failed-payment`]?.total_order || 0;
                this.distributor.totalActiveSeller =
                    data[`${user}-total-active-seller`]?.count || 0;
                this.distributor.totalNewSeller =
                    data[`${user}-total-new-merchant`]?.count || 0;
            } catch (error) {
                this.$toasted.error("Data not found!");
            }
        },
        async getSellerDashboardInfo() {
            this.loading = true;
            const keyList = [
                "seller-total-orders",
                "seller-cancelled-orders",
                "seller-item-low-stock",
                "seller-item-outofstock",
                "seller-returned-orders",
                "seller-total-items",
                "seller-completed-orders",
                "seller-online-items",
                "seller-offline-items",
                "seller-pending-orders",
            ];
            let variablesObj = {
                ...this.getDateInfo(this.selectedDate1.value),
                userId: this.userId,
                tenant: this.tenantId,
            };
            let items = [];
            keyList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {
                        ...variablesObj,
                    },
                });
            });
            items.push({
                key: "seller-live-order",
                variables: {
                    userId: this.userId,
                    Date: moment().format("YYYY-MM-DD"),
                },
            });
            const data = await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                {
                    items: items,
                },
            );

            try {
                this.dashboard.totalOrders =
                    data["seller-total-orders"]["total_order"];
                this.dashboard.totalCancelledOrders =
                    data["seller-cancelled-orders"]["total_order"];
                this.dashboard.totalReturnedOrders =
                    data["seller-returned-orders"]["total_order"];
                this.dashboard.totalOrderCompleted =
                    data["seller-completed-orders"]["total_order"];
                this.dashboard.totalItems = data["seller-total-items"].items;
                this.dashboard.totalOfflineItems =
                    data["seller-offline-items"].items;
                this.dashboard.totalPendingApproval =
                    data["seller-pending-orders"]["total_order"];
                // this.dashboard.totalItemLowStock = data["seller-item-low-stock"]["low_stock"];
                this.dashboard.totalItemSoldOut =
                    data["seller-item-outofstock"].outofstock;
                this.dashboard.totalOnlineItems =
                    data["seller-online-items"].items;
                this.dashboard.totalLiveOrders =
                    data["seller-live-order"]["order_count"];
            } catch (err) {
                this.$toasted.error("Data not found!");
            } finally {
                this.loading = false;
            }
        },
        async getTenantAnalyticsData() {
            this.isLoading = true;
            const keyList = [
                "total-partners",
                "total-items",
                "total-customers",
                "total-orders",
                "total-servicerequests",
            ];
            let variablesObj = {
                tenant: this.userId,
                ...this.getDateInfo(this.selectedDate1.value),
            };
            let items = [];
            keyList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {
                        ...variablesObj,
                    },
                });
            });

            await this.$store
                .dispatch("partner/fetchBulkAnalyticReport", { items: items })
                .then((data) => {
                    this.dashboard.partnerCount =
                        data["total-partners"][0].count;
                    this.dashboard.totalItems = data["total-items"].items;
                    this.dashboard.totalCustomers =
                        data["total-customers"].total_customer;
                    this.dashboard.totalOrders =
                        data["total-orders"].total_order;
                    this.dashboard.totalAmount =
                        data["total-orders"].total_order_amount || 0;
                    this.dashboard.totalService =
                        Number(
                            data["total-servicerequests"]
                                .closed_servicerequest || 0,
                        ) +
                        Number(
                            data["total-servicerequests"].open_servicerequest ||
                                0,
                        ) +
                        Number(
                            data["total-servicerequests"]
                                .total_servicerequest || 0,
                        );
                });
            this.isLoading = false;
        },
        async getAdminAnalyticsData() {
            const keyList = [
                "admin-total-tenants",
                "total-markets",
                "total-users",
                "total-business-plan",
                "total-attributes",
                "total-features",
                "total-subscriptions",
                "total-permission",
                "total-roles",
            ];
            const items = [];
            keyList.forEach((el) => {
                items.push({
                    key: el,
                    variables: {},
                });
            });

            await this.$store
                .dispatch("partner/fetchBulkAnalyticReport", { items: items })
                .then((data) => {
                    this.loading = false;
                    this.adminDashboard.tenantCount =
                        data["admin-total-tenants"].count;
                    this.adminDashboard.totalAttributes =
                        data["total-attributes"].count;
                    this.adminDashboard.totalBusinessPlans =
                        data["total-business-plan"].count;
                    this.adminDashboard.totalFeatures =
                        data["total-features"].count;
                    this.adminDashboard.totalMarkets =
                        data["total-markets"].count;
                    this.adminDashboard.totalSubscriptions =
                        data["total-subscriptions"].count;
                    this.adminDashboard.totalUsers = data["total-users"].count;
                    this.adminDashboard.totalPermissions =
                        data["total-permission"].count;
                    this.adminDashboard.totalRoles = data["total-roles"].count;
                });
        },
        getAnalyticsDataAll() {
            if (this.$userRole === "Tenant" && this.userId) {
                this.getTenantAnalyticsData();
                this.fetchTenantOrderChart();
                this.fetchTopMarketRevenueData();
            } else if (this.$userRole === "Partner" && this.userId) {
                if (this.$currentUserData.category === "SELLER") {
                    this.getSellerDashboardInfo();
                    return;
                } else {
                    this.getDealerDistributorInfo();
                }
            } else if (this.$userRole === "Admin" && this.userId) {
                this.getAdminAnalyticsData();
                this.fetchAdminOrderChart();
            }
        },
        async fetchTopMarketRevenueData() {
            this.isTopMarketLoading = true;
            const dataList = [
                {
                    key: "top-revenue-market-report",
                    variables: {
                        tenant: this.userId,
                        ...this.getDateInfo(this.selectedDate3.value),
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchTopMarketData", {
                items: dataList,
            });
            this.isTopMarketLoading = false;
        },
        async fetchSellerTopMarketRevenue() {
            this.isTopMarketLoading = true;
            const dataList = [
                {
                    key: "seller-top-revenue-market-report",
                    variables: {
                        ...this.getDateInfo(this.selectedDate3.value),
                        userId: this.userId,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchTopMarketData", {
                items: dataList,
            });
            this.isTopMarketLoading = false;
        },
        async fetchAdminTopMarketRevenue() {
            this.isTopMarketLoading = true;
            const dataList = [
                {
                    key: "admin-top-revenue-market-report",
                    variables: {
                        ...this.getDateInfo(this.selectedDate3.value),
                        userId: this.userId,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchTopMarketData", {
                items: dataList,
            });
            this.isTopMarketLoading = false;
        },
        async fetchTenantOrderChart() {
            this.isLoading = true;
            const dataList = [
                {
                    key: "total-order-report-graph",
                    variables: {
                        tenant: this.userId,
                        ...this.getDateInfo(this.selectedDate2.value),
                    },
                },
            ];
            const data = await this.$store.dispatch("partner/fetchBulkChart", {
                items: dataList,
            });
            this.isLoading = false;
        },
        getStatusData(statusData) {
            let data = {};
            const useAllStatus =
                statusData.length === 0 ||
                statusData.some((el) => el === "All Status");
            const sourceArray = useAllStatus
                ? this.statusOptions.filter((el) => el !== "All Status")
                : statusData;
            const startIndex = useAllStatus ? 0 : 1;
            sourceArray.forEach((el, index) => {
                data[`status${startIndex + index}`] = el;
            });
            return data;
        },
        async fetchSellerOrderChart() {
            this.isLoading = true;
            const data = [
                {
                    key: "seller-total-order-report-graph",
                    variables: {
                        ...this.getDateInfo(this.selectedDate2.value),
                        userId: this.userId,
                    },
                },
            ];
            await this.$store.dispatch("partner/fetchBulkChart", {
                items: data,
            });
            this.isLoading = false;
        },
        async fetchAdminOrderChart() {
            this.isLoading = true;
            let keyString = "orderbyvalue-graph";
            if (this.selectedTenant.text === "All Tenants") {
                keyString = "all-tenants-orderbyvalue-graph";
            }
            const dataList = [
                {
                    key: keyString,
                    variables: {
                        tenant: this.selectedTenant.value,
                        ...this.getDateInfo(this.selectedDate2.value),
                        ...this.getStatusData(this.selectedStatusOptions),
                    },
                },
            ];
            if (this.selectedTenant.text === "All Tenants") {
                delete dataList[0].variables.tenant;
            }
            try {
                await this.$store.dispatch("partner/fetchBulkChart", {
                    items: dataList,
                });
            } finally {
                this.isLoading = false;
            }
        },
    },
    async mounted() {
        this.loading = false;
        this.getAnalyticsDataAll();
        if (this.$currentUserData.category === "SELLER" && this.userId) {
            this.fetchSellerOrderChart();
            this.sellerDashboardData();
            this.sellerStockPrediction();
        }
        if (this.$userRole === "Admin") {
            this.fetchAdminTopMarketRevenue();
            this.fetchAdminOrderChart();
        }
    },
};
</script>

<style scoped>
.dashboard-select {
    background-color: #fff;
    margin-bottom: 0;
}

.pagination-div {
    float: right;
}

/* IE fix */
#card-chart-01,
#card-chart-02 {
    width: 100% !important;
}

.head-text {
    margin-bottom: 0px;
    font-size: 18px;
    font-weight: 600;
    color: #000000;
}

.dashboard-header {
    /* background: var(--bgcolour); */
    display: flex;
    align-items: center;
}

.row-cols-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
    padding: 0.5rem;
}

.g-3 {
    margin: -0.5rem;
}

.g-3 > * {
    padding: 0.5rem;
}

.flex-grow-1 {
    flex: 1 1 0;
    min-width: 0;
}

.chart-doughnut {
    width: 100%;
    height: 390px;
    max-height: 390px;
    display: block;
}

.chartSec {
    max-height: 470px;
    height: 470px;
    border-radius: 16px;
    overflow: hidden;
}

@media (min-width: 768px) and (max-width: 991.98px) {
    .chartSec {
        height: 420px;
        max-height: 420px;
    }

    .chart-doughnut {
        height: 320px;
        max-height: 320px;
    }
}
.product-img {
    width: 45px;
    height: 45px;
    border-radius: 8px;
    object-fit: cover;
}

.loader-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    z-index: 99999;
}

.custom-table {
    border: 1px solid #d1d5db;
    /* gray-300 */
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 12px;
    overflow: hidden;
    background: white;
}

/* row border */
.table-row {
    border-bottom: 1px solid #d1d5db;
    text-align: center;
}

/* vertical column border */
.cell-border {
    border-right: 1px solid #d1d5db;
}

/* remove right border for last cell */
.table-row td:last-child {
    border-right: none;
}
.noDataAvai {
    height: 100%;
    min-height: 250px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.reorder-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background-color: #1e63f0;
    /* close to image blue */
    color: #ffffff;
    padding: 10px 18px;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.reorder-btn i {
    font-size: 14px;
}

.reorder-btn:hover {
    background-color: #1957d2;
}

.product-img-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    background-color: #f1f3f5;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.product-img {
    width: 40px;
    height: 40px;
    object-fit: contain;
}

.product-name {
    font-size: 14px;
    font-weight: 500;
    color: #212529;
    line-height: 1.3;
}

.risk-badge {
    display: inline-block;
    margin-top: 4px;
    padding: 2px 8px;
    font-size: 11px;
    font-weight: 600;
    border-radius: 5px;
    letter-spacing: 0.3px;
}

.badge-critical {
    background-color: #fde8e8;
    color: #d9534f;
}

.badge-high {
    background-color: #fff3cd;
    color: #f0ad4e;
}

.badge-default {
    background-color: #e9ecef;
    color: #6c757d;
}
.dashbordModalHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    padding-top: 0px;
}

.dashbordModalHeader span {
    font-size: 24px;
    color: var(--primary);
}

.dashboard-status {
    text-transform: uppercase;
}

@media (max-width: 991.98px) {
    .chartSec {
        height: auto;
        min-height: 300px;
        max-height: none;
        overflow: visible !important;
    }
    .chart-doughnut {
        max-height: 300px;
    }
}

@media (max-width: 767.98px) {
    .chartSec {
        min-height: 250px;
    }
    .dashboard-summary-row {
        row-gap: 0.75rem;
    }
    .dashboard-summary-row > .mt-2 {
        margin-top: 0 !important;
    }
    .dashboard-header {
        flex-direction: column;
        align-items: flex-start !important;
    }
    .dashboard-drop {
        width: 100%;
        margin-top: 0.5rem;
    }
    .dash-text {
        font-size: 1.25rem;
        margin-bottom: 0.5rem;
    }
    .tenant-dash-text {
        font-size: 1.25rem;
        margin-bottom: 0.5rem;
    }
    .row-cols-5 > * {
        flex: 0 0 50%;
        max-width: 50%;
    }
}

@media (max-width: 1200px) {
    .row-cols-5 > * {
        flex: 0 0 33.333%;
        max-width: 33.333%;
    }
}

@media (max-width: 576px) {
    .row-cols-5 > * {
        flex: 0 0 100%;
        max-width: 100%;
    }
}
</style>
